import { Form, Row } from "antd";
import PlamoApiWithSaveNotifications from "../../../util/with-save-notification";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import FormItem, { createRegexRule } from "../../../form/form-item";
import { AdvancedForm } from "../../../form/advanced-form";

const { useCreateInsuranceWithSaveNotificationMutation, useUpdateInsuranceWithSaveNotificationMutation } = PlamoApiWithSaveNotifications;

function InsuranceMainForm({ insuranceId, insurance }) {
  const [createInsurance, { isLoading: isCreatingEmployee }] = useCreateInsuranceWithSaveNotificationMutation()
  const [updateInsurance, { isLoading: isUpdatingEmployee }] = useUpdateInsuranceWithSaveNotificationMutation()
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const isLoading = isCreatingEmployee || isUpdatingEmployee;

  const onFinish = useCallback(async (values: any) => {
    if(!insuranceId) {
      const { data: newInsurance }:any = await createInsurance(values);
      navigate(`./../${newInsurance.id}`)
    } else {
      const newInsurance = {...insurance, ...values}
      await updateInsurance(newInsurance);
    }
  }, [insuranceId, createInsurance, updateInsurance, navigate, insurance]);

  return (
    <>
    <AdvancedForm form={form} name="customer" onFinish={onFinish} isLoading={isLoading} originalValues={insurance} initialEditing={!insuranceId}>
    <Row><h3>Basisdaten</h3></Row>
    <Row gutter={24}>
      <FormItem fieldName="name" label="Name" />
    </Row>
    <Row><h3>Standardadresse</h3></Row>
    <Row gutter={24}>
      <FormItem fieldName="defaultAddressRecipient1" label="Empfängerzeile 1" />
      <FormItem fieldName="defaultAddressRecipient2" label="Empfängerzeile 2" />
    </Row>
    <Row gutter={24}>
      <FormItem fieldName="defaultAddressStreet" label="Straße" />
      <FormItem fieldName="defaultAddressHousenumber" label="Hausnummer" />
      <FormItem fieldName="defaultAddressZipCode" label="PLZ" rules={[createRegexRule(/^\d{5}$/, 'Keine gültige PLZ')]} />
      <FormItem fieldName="defaultAddressCity" label="Ort" />
    </Row>
  </AdvancedForm>
  </>)
}

export default InsuranceMainForm;